import React from "react";
import { render } from "react-dom";
import { Translation, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default class TeamStatisticsDashboard extends React.Component{

    render() {

        const {
            teamStatistics,
            handleColor
        } = this.props;

        return (
            <Translation ns="translation">
            {(t, { i18n }) => {
                return (
                    <div className="col-md-6 m-b-30">
                        <div className="card">
                            <div className="card-header py-3">
                            <h4 className="h6 m-0">
                                {t("dashBoard.teamStatics")}
                            </h4>
                            </div>
                            <div id="collapse-collapsed1" class="collapse collapse-panel" aria-labelledby="heading-collapsed">
                            <div className="card-body pb-0">
                                <div className="table-responsive table-scroll">
                                    <table className="table table-bordered small-table m-0">
                                        <thead className="bg-light">
                                            <tr>
                                            <th className="w-80p">
                                                {" "}
                                                {t("dashBoard.rank")}
                                            </th>
                                            <th className="w-150p">
                                                {" "}
                                                {t("dashBoard.team")}
                                            </th>
                                            <th> {t("dashBoard.result")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {teamStatistics &&
                                            teamStatistics.map((item, index) => {
                                                return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.name && item.name} </td>
                                                    <td>
                                                    <div className="progress">
                                                        <div
                                                        className={handleColor(item.result)}
                                                        role="progressbar"
                                                        style={{
                                                            width: `${item.result}%`,
                                                        }}
                                                        aria-valuenow="75"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                        ></div>
                                                    </div>
                                                    </td>
                                                </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            </div>
                            <div className="card-footer border-0">
                                <div className="text-right">
                                <Link
                                    to="/statistics/team"
                                    className="font-weight-600"
                                >
                                    {t("dashBoard.moreDetails")}
                                </Link>
                                </div>
                                <div className="text-left">
                                <a class="collapsed d-block" data-toggle="collapse" href="#collapse-collapsed1" aria-expanded="true" aria-controls="collapse-collapsed" id="heading-collapsed"><i class="fa fa-chevron-up pull-right"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
            </Translation>
        )
    }
}